<template>
  <div class="statistics-container">
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>采购情况统计</span>
      </div>
    </div>

    <div class="search-area">
      <el-date-picker
        v-model="startDate"
        type="date"
        placeholder="查询时间起"
        aria-label="查询时间起"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input date-picker"
      ></el-date-picker>
      <el-date-picker
        v-model="endDate"
        type="date"
        placeholder="查询时间止"
        aria-label="查询时间止"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input date-picker"
      ></el-date-picker>
      <el-input
        v-model="searchParams.contractName"
        placeholder="合同名称"
        clearable
        class="search-input"
        prefix-icon="el-icon-search"
      ></el-input>
      <el-input
        v-model="searchParams.supplierName"
        placeholder="供应商"
        clearable
        class="search-input"
        prefix-icon="el-icon-office-building"
      ></el-input>
      <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
      <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
    </div>

    <div class="summary-cards">
      <el-row :gutter="16">
        <el-col :span="4">
          <el-card shadow="hover" class="summary-card">
            <div class="card-label">合同数量</div>
            <div class="card-value">{{ summary.contractCount }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card shadow="hover" class="summary-card">
            <div class="card-label">订单数量</div>
            <div class="card-value">{{ summary.orderCount }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card shadow="hover" class="summary-card">
            <div class="card-label">产品总数量</div>
            <div class="card-value">{{ summary.productQuantity }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card shadow="hover" class="summary-card">
            <div class="card-label">已发货数量</div>
            <div class="card-value">{{ summary.shippedQuantity }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card shadow="hover" class="summary-card">
            <div class="card-label">订单总金额（含税）</div>
            <div class="card-value highlight">{{ formatAmount(summary.orderAmountWithTax) }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card shadow="hover" class="summary-card">
            <div class="card-label">订单总金额（不含税）</div>
            <div class="card-value">{{ formatAmount(summary.orderAmountWithoutTax) }}</div>
          </el-card>
        </el-col>
      </el-row>
      <el-row :gutter="16" style="margin-top: 16px;">
        <el-col :span="6">
          <el-card shadow="hover" class="summary-card">
            <div class="card-label">结算单数量</div>
            <div class="card-value">{{ summary.settlementCount }}</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" class="summary-card">
            <div class="card-label">结算金额（含税）</div>
            <div class="card-value highlight">{{ formatAmount(summary.settlementAmountWithTax) }}</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" class="summary-card">
            <div class="card-label">结算金额（不含税）</div>
            <div class="card-value">{{ formatAmount(summary.settlementAmountWithoutTax) }}</div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div class="table-area">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="product-list-wrapper">
              <div class="product-list-title">产品清单</div>
              <el-table
                :data="scope.row.productList || []"
                border
                size="small"
                :header-cell-style="{ background: '#fafafa', color: '#606266' }"
              >
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="productName" label="产品名称" min-width="150" align="center"></el-table-column>
                <el-table-column prop="specification" label="规格型号" min-width="120" align="center"></el-table-column>
                <el-table-column prop="unit" label="单位" width="80" align="center"></el-table-column>
                <el-table-column prop="quantity" label="数量" width="100" align="right"></el-table-column>
                <el-table-column prop="shippedQuantity" label="已发货数量" width="110" align="right"></el-table-column>
                <el-table-column prop="amountWithTax" label="金额(含税)" width="120" align="right">
                  <template slot-scope="inner">
                    {{ formatAmount(inner.row.amountWithTax) }}
                  </template>
                </el-table-column>
                <el-table-column prop="amountWithoutTax" label="金额(不含税)" width="130" align="right">
                  <template slot-scope="inner">
                    {{ formatAmount(inner.row.amountWithoutTax) }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="contractName" label="合同名称" min-width="200" align="center"></el-table-column>
        <el-table-column prop="supplierName" label="供应商" min-width="150" align="center"></el-table-column>
        <el-table-column prop="orderCount" label="订单数量" width="100" align="center"></el-table-column>
        <el-table-column prop="productQuantity" label="产品数量" width="100" align="right"></el-table-column>
        <el-table-column prop="shippedQuantity" label="已发货数量" width="110" align="right"></el-table-column>
        <el-table-column prop="orderAmountWithTax" label="订单金额(含税)" width="130" align="right">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.orderAmountWithTax) }}
          </template>
        </el-table-column>
        <el-table-column prop="orderAmountWithoutTax" label="订单金额(不含税)" width="140" align="right">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.orderAmountWithoutTax) }}
          </template>
        </el-table-column>
        <el-table-column prop="settlementCount" label="结算单数量" width="110" align="center"></el-table-column>
        <el-table-column prop="settlementAmountWithTax" label="结算金额(含税)" width="130" align="right">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.settlementAmountWithTax) }}
          </template>
        </el-table-column>
        <el-table-column prop="settlementAmountWithoutTax" label="结算金额(不含税)" width="140" align="right">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.settlementAmountWithoutTax) }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PurchaseStatistics',
  data() {
    return {
      startDate: '',
      endDate: '',
      searchParams: {
        contractName: '',
        supplierName: ''
      },
      loading: false,
      summary: {
        contractCount: 0,
        orderCount: 0,
        productQuantity: 0,
        shippedQuantity: 0,
        orderAmountWithTax: 0,
        orderAmountWithoutTax: 0,
        settlementCount: 0,
        settlementAmountWithTax: 0,
        settlementAmountWithoutTax: 0
      },
      tableData: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    handleSearch() {
      this.loadData()
    },
    handleReset() {
      this.startDate = ''
      this.endDate = ''
      this.searchParams = { contractName: '', supplierName: '' }
      this.loadData()
    },
    formatAmount(amount) {
      if (amount === undefined || amount === null) return '0.00'
      return Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    loadData() {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        this.$message.warning('查询时间起不能晚于查询时间止')
        return
      }
      this.loading = true
      setTimeout(() => {
        const data = this.getPurchaseData()
        let filtered = data.tableData
        if (this.searchParams.contractName) {
          filtered = filtered.filter(row => (row.contractName || '').includes(this.searchParams.contractName))
        }
        if (this.searchParams.supplierName) {
          filtered = filtered.filter(row => (row.supplierName || '').includes(this.searchParams.supplierName))
        }
        this.tableData = filtered
        this.summary = data.summary
        this.loading = false
      }, 300)
    },
    getPurchaseData() {
      const tableData = [
        {
          contractName: '钢筋采购合同',
          supplierName: '钢筋厂',
          orderCount: 10,
          productQuantity: 980,
          shippedQuantity: 750,
          orderAmountWithTax: 987600,
          orderAmountWithoutTax: 874070.80,
          settlementCount: 6,
          settlementAmountWithTax: 620000,
          settlementAmountWithoutTax: 548672.57,
          productList: [
            { productName: '螺纹钢', specification: 'HRB400 Φ12', unit: '吨', quantity: 450, shippedQuantity: 350, amountWithTax: 457650, amountWithoutTax: 405000 },
            { productName: '螺纹钢', specification: 'HRB400 Φ16', unit: '吨', quantity: 350, shippedQuantity: 280, amountWithTax: 355950, amountWithoutTax: 315000 },
            { productName: '混凝土', specification: 'C30', unit: '立方米', quantity: 180, shippedQuantity: 120, amountWithTax: 174000, amountWithoutTax: 154070.80 }
          ]
        },
        {
          contractName: '钢材采购框架合同',
          supplierName: '唐山钢铁',
          orderCount: 14,
          productQuantity: 1560,
          shippedQuantity: 1200,
          orderAmountWithTax: 1560000,
          orderAmountWithoutTax: 1380530.97,
          settlementCount: 9,
          settlementAmountWithTax: 1020000,
          settlementAmountWithoutTax: 902654.87,
          productList: [
            { productName: 'Q235B钢材', specification: '20*200*6000mm', unit: '吨', quantity: 600, shippedQuantity: 480, amountWithTax: 610200, amountWithoutTax: 540000 },
            { productName: 'Q345B钢材', specification: '25*250*6000mm', unit: '吨', quantity: 500, shippedQuantity: 400, amountWithTax: 565500, amountWithoutTax: 500442.48 },
            { productName: '不锈钢螺栓', specification: 'M12*50 304', unit: '个', quantity: 460, shippedQuantity: 320, amountWithTax: 384300, amountWithoutTax: 340088.49 }
          ]
        },
        {
          contractName: '混凝土采购合同',
          supplierName: '华西混凝土',
          orderCount: 7,
          productQuantity: 720,
          shippedQuantity: 580,
          orderAmountWithTax: 678000,
          orderAmountWithoutTax: 600000.00,
          settlementCount: 4,
          settlementAmountWithTax: 380000,
          settlementAmountWithoutTax: 336283.19,
          productList: [
            { productName: '混凝土', specification: 'C25', unit: '立方米', quantity: 350, shippedQuantity: 280, amountWithTax: 316750, amountWithoutTax: 280309.73 },
            { productName: '混凝土', specification: 'C30', unit: '立方米', quantity: 370, shippedQuantity: 300, amountWithTax: 361250, amountWithoutTax: 319690.27 }
          ]
        },
        {
          contractName: '水泥采购年度合同',
          supplierName: '海螺水泥',
          orderCount: 5,
          productQuantity: 380,
          shippedQuantity: 320,
          orderAmountWithTax: 425000,
          orderAmountWithoutTax: 376106.19,
          settlementCount: 3,
          settlementAmountWithTax: 265000,
          settlementAmountWithoutTax: 234513.27,
          productList: [
            { productName: '水泥', specification: 'P.O 42.5', unit: '吨', quantity: 220, shippedQuantity: 180, amountWithTax: 242000, amountWithoutTax: 214159.29 },
            { productName: '水泥', specification: 'P.O 52.5', unit: '吨', quantity: 160, shippedQuantity: 140, amountWithTax: 183000, amountWithoutTax: 161946.90 }
          ]
        },
        {
          contractName: '方木采购协议',
          supplierName: '木材加工厂',
          orderCount: 3,
          productQuantity: 150,
          shippedQuantity: 100,
          orderAmountWithTax: 158000,
          orderAmountWithoutTax: 139823.01,
          settlementCount: 2,
          settlementAmountWithTax: 105000,
          settlementAmountWithoutTax: 92920.35,
          productList: [
            { productName: '方木', specification: '50×100', unit: '立方米', quantity: 100, shippedQuantity: 70, amountWithTax: 105200, amountWithoutTax: 93097.35 },
            { productName: '模板', specification: '15mm', unit: '张', quantity: 50, shippedQuantity: 30, amountWithTax: 52800, amountWithoutTax: 46725.66 }
          ]
        }
      ]
      const summary = {
        contractCount: 5,
        orderCount: 39,
        productQuantity: 3790,
        shippedQuantity: 2950,
        orderAmountWithTax: 3802600,
        orderAmountWithoutTax: 3365535.97,
        settlementCount: 24,
        settlementAmountWithTax: 2390000,
        settlementAmountWithoutTax: 2115044.25
      }
      return { tableData, summary }
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics-container {
  padding: 20px;
}
.page-header {
  margin-bottom: 20px;
}
.header-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}
.title-mark {
  width: 4px;
  height: 18px;
  background: #409EFF;
  margin-right: 10px;
}
.search-area {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.search-input {
  width: 200px;
}
.date-picker {
  width: 200px;
}
.summary-cards {
  margin-bottom: 20px;
}
.summary-card {
  .card-label {
    font-size: 13px;
    color: #606266;
    margin-bottom: 8px;
  }
  .card-value {
    font-size: 22px;
    font-weight: bold;
    color: #303133;
    &.highlight {
      color: #409EFF;
    }
  }
}
.table-area {
  margin-bottom: 20px;
}
.product-list-wrapper {
  padding: 16px 24px;
  background: #fafafa;
}
.product-list-title {
  font-weight: bold;
  margin-bottom: 12px;
  color: #303133;
}
::v-deep .el-table th {
  background-color: #f5f7fa !important;
  color: #606266 !important;
  font-weight: 600;
}
</style>
